<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="small-panel" @click.stop>
                <div class="dialog-title" v-if="!showTokenResult" v-t="'message.title_issue_token_dialog'">
                </div>
                <div class="dialog-title" v-if="showTokenResult" v-t="'message.msg_token_issued'">
                </div>
                <hr class="dialog-hr">
                <div class="dialog-body-small">
                    <div v-if="!showTokenResult">
                        <div v-if="appData.e2eEncryption" class="error-section">
                            <span style="color:red">{{$t('message.error_token_issue_unavailable_with_e2e_encryption')}}</span>
                        </div>
                        <template v-else>
                            <div class="description-section" v-html="$t('message.desc_issue_token_dialog')">
                            </div>
                            <div class="permission-section">
                                <div class="permission-switch">
                                    <div style="margin-right:10px;">
                                        <span v-t="'message.item_grant_level_permissions_at_the_creation'"></span>
                                    </div>
                                    <el-select
                                        class="select-option-item"
                                        v-model="grantLevelPermissionsAtCreation"
                                        :disabled="grantLevelPermissionsList.length === 1">
                                        <el-option
                                            v-for="grantLevelPermission in grantLevelPermissionsList"
                                            :key="grantLevelPermission.type"
                                            :label="grantLevelPermission.displayName"
                                            :value="grantLevelPermission.type"/>
                                    </el-select>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div v-if="showTokenResult" class="token-result-section">
                        <div class="token-description" v-t="'message.msg_token_copy_instruction'">
                        </div>
                        <div class="token-display">
                            <input
                                type="text"
                                :value="issuedToken"
                                readonly
                                class="token-input"
                                ref="tokenInput"
                                @click="selectToken"
                            />
                            <el-button
                                class="copy-button"
                                @click="copyToken"
                                size="small"
                                v-t="'message.action_copy'"
                            >
                            </el-button>
                        </div>
                        <div class="token-info">
                            <p v-t="'message.msg_token_cannot_redisplay'"></p>
                            <p v-t="'message.msg_token_valid_duration'"></p>
                        </div>
                    </div>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button v-if="!showTokenResult" class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button v-if="!showTokenResult && !appData.e2eEncryption" class="dialog-ok-button" @click="issueToken" v-t="'message.action_issue_token'"></el-button>
                    <el-button v-if="showTokenResult" class="dialog-ok-button" @click="closeDialog" v-t="'message.action_close'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import server from "./ServerApi.js";
import commonUtil from './commonutil.js';
import Constants from "./constants";

export default {
    props: {
        tenantId: Number,
        appData: Object
    },

    data () {
        return {
            grantLevelPermissionsList: [],

            showTokenResult: false,

            grantLevelPermissionsAtCreation: Constants.GRANT_LEVEL_PERMISSION.NONE,
            issuedToken: ''
        };
    },

    created: function() {
        this.grantLevelPermissionsList = commonUtil.getConsoleOperationPermissions(this.$i18n)
    },

    methods: {
        issueToken() {
            let self = this;
            // トークン発行のAPI呼び出し処理
            let param = {
                tenantId: this.tenantId,
                permissions: {
                    grantLevelPermissionsAtCreation : this.grantLevelPermissionsAtCreation,
                }
            };

            server.post('/issueipradiointegrationtoken', param)
                .then((res) => {
                    if (res.data.status === Constants.STATUS_SUCCESS) {
                        self.issuedToken = res.data.token;
                        self.showTokenResult = true;
                        commonUtil.notifyMessage(this, "Success", this.$t("message.msg_token_issue_success"))
                    } else if (res.data.status === Constants.STATUS_ERROR_ALREADY_EXISTED) {
                        commonUtil.notifyMessage(self, "Warning", self.$t("message.msg_token_already_exists"));
                    } else if (res.data.status === Constants.STATUS_ERROR_DENIED) {
                        commonUtil.notifyMessage(self, "Error", self.$t("message.error_token_issue_unavailable_with_e2e_encryption"));
                    } else {
                        commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_token_issue_failed"));
                    }
                })
                .catch((error) => {
                    commonUtil.notifyMessage(self, "Error", self.$t("message.msg_api_call_error") + error.message);
                });
        },
        copyToken() {
            // トークンをクリップボードにコピー
            if (navigator.clipboard) {
                navigator.clipboard.writeText(this.issuedToken).then(() => {
                    commonUtil.notifyMessage(this, "Success", this.$t("message.msg_token_copied"));
                }).catch(() => {
                    this.selectToken();
                    commonUtil.notifyMessage(this, "Info", this.$t("message.msg_token_selected"));
                });
            } else {
                this.selectToken();
                commonUtil.notifyMessage(this, "Info", this.$t("message.msg_token_selected"));
            }
        },
        selectToken() {
            // トークン入力フィールドを選択
            this.$nextTick(() => {
                if (this.$refs.tokenInput) {
                    this.$refs.tokenInput.select();
                }
            });
        },
        closeDialog() {
            this.$emit('issued', { token: this.issuedToken, partialPermission: this.partialPermission });
        }
    }
}
</script>

<style scoped>
.dialog-body-small {
    max-height: calc(80vh - 150px);
    padding: 10px 20px;
    font-size: 14px;
    overflow-x: hidden;
    overflow-y: visible;
}

.description-section {
    margin-bottom: 20px;
}

.permission-section {
    margin-bottom: 20px;
}

.permission-switch {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.permission-label {
    margin-right: 15px;
    font-weight: bold;
}

.permission-details {
    margin-left: 20px;
    color: #999;
    font-size: 14px;
}

.permission-list {
    line-height: 16px;
}

.permission-item {
    display: block;
}

/* トークン表示のスタイル */
.token-result-section {
    padding: 20px;
    text-align: center;
}

.token-description {
    margin-bottom: 15px;
    font-size: 14px;
    color: #333;
}

.token-display {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    gap: 10px;
}

.token-input {
    flex: 1;
    padding: 12px;
    font-family: 'Courier New', monospace;
    font-size: 14px;
    border: 2px solid #ddd;
    border-radius: 4px;
    background-color: #f9f9f9;
    text-align: center;
    letter-spacing: 1px;
    cursor: pointer;
}

.token-input:focus {
    outline: none;
    border-color: #5a7de8;
    background-color: #fff;
}

.copy-button {
    background-color: #5a7de8;
    color: white;
    border: none;
    padding: 12px 20px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    min-width: 80px;
}

.copy-button:hover {
    background-color: #4a6dd7;
}

.token-info {
    text-align: left;
    color: #666;
    font-size: 13px;
    line-height: 1.5;
    background-color: #f8f9fa;
    padding: 15px;
    border-radius: 4px;
    border-left: 4px solid #5a7de8;
}

.token-info p {
    margin: 0 0 5px 0;
}

.token-info p:last-child {
    margin-bottom: 0;
}
</style>
